import Vue from "vue";
import axios from "axios";
import "../../../../filters";
import moment from "moment";
import users from "../../../../users";

export default {
  name: "SelectCustomer",
  mixins: [users],
  components: {
    DataGridComp: require("../../../../customcontrols/datagrid.vue").default,
    filterDataComp: require("../../../../customcontrols/filterData.vue")
      .default,
  },
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
    isMasterCustomer: {
      type: Boolean,
      default: false,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      mainApplicationId: -1,
      appId: -1,

      keyColumn: "customerKey",

      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      customersCols: [],

      noDataFound: false,
      showPropertiesList: false,
    };
  },
  computed: {
    showSelectedPanel: function () {
      return (
        this.dataObj &&
        this.dataObj.customer &&
        this.dataObj.customer.customerKey
      );
    },
  },
  created() {
    this.$root.$on("select_customer_updated", this.init);
    this.fillCustomersCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.fillFiltersObj();
      });
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getCustomers();
    },
    getCustomers() {
      if (this.isOffline) {
        this.dataObj.customers =
          this.$store.state.offlineApplicationsData.activityLookups[
            this.dataObj.appKey
          ]["customers"];
        this.options.total = this.dataObj.customers.length;
        this.totalRow = 0;
      } else {
        var criteria = {};

        for (
          var i = 0;
          i < this.dataObj.filterObj.filter((a) => a.added).length;
          i++
        ) {
          criteria[this.dataObj.filterObj.filter((a) => a.added)[i].field] =
            this.dataObj.filterObj.filter((a) => a.added)[i].value;
        }

        let parameter = {
          ApplicationId: this.appId,
          ApplicationKey: 0,
          Filters: criteria,
          Options: this.options,
        };

        let url;
        if (this.isMasterCustomer == true)
          url = "/SelectMasterCustomerActivity/GetMasterCustomers";
        else url = "/SelectCustomerActivity/GetActivityCustomers";

        this.$store.state.notifier.asyncBlock(
          axios.post(url, parameter),
          (resp) => {
            if (resp.status == 200) {
              if (resp.data.items.length == 0) {
                this.dataObj.customers = [];
                this.noDataFound = true;
              } else {
                console.log(resp.data.items);
                this.dataObj.customers = resp.data.items;
                this.options.total = resp.data.itemsCount;
                this.totalRow = resp.data.itemsCount;
              }
            } else this.$alertMsg(resp.data.data.text);
          },
          (err) => {
            this.$alertMsg(err.response.data);
          }
        );
      }
    },
    onSelectCustomer(info) {
      if (info.newRowIndex < 0) return;

      var cust = info.data;
      if (cust === null || cust === undefined) return;

      this.dataObj.customer = cust;
    },
    applyFilter() {
      this.getCustomers();
    },
    fillCustomersCols() {
      this.customersCols.push({
        dataField: "billingGroupStr",
        caption: this.$t("activities.billingGroup"),
      });
      this.customersCols.push({
        dataField: "customerKey",
        caption: this.$t("activities.account"),
      });
      this.customersCols.push({
        dataField: "surname",
        caption: this.$t("activities.surname"),
      });
      this.customersCols.push({
        dataField: "idNumber",
        caption: this.$t("activities.initial"),
      });
      this.customersCols.push({
        dataField: "address",
        caption: this.$t("activities.address"),
      });
      this.customersCols.push({
        dataField: "consumerTypeStr",
        caption: this.$t("activities.consumerType"),
      });
      this.customersCols.push({
        dataField: "telephoneNumber",
        caption: this.$t("activities.telephoneNumber"),
      });
      this.customersCols.push({
        dataField: "cellPhone",
        caption: this.$t("activities.cellPhone"),
      });
    },
    fillFiltersObj() {
      if (this.dataObj.filterObj.length > 0) return;

      if (!this.isOffline) {
        this.dataObj.filterObj.push({
          defaultIndex: 0,
          index: 0,
          field: "BillingGroup",
          fieldDesc: this.$t("activities.billingGroup"),
          type: "list",
          listSource: this.dataObj.billingGroups.sort(
            (a, b) => a.value - b.value
          ),
          listValueField: "value",
          listTextField: "text",
          addedDefault: true,
          defaultValue: "-1",
          value: "-1",
          added: true,
        });

        this.dataObj.filterObj.push({
          defaultIndex: 1,
          index: 1,
          field: "ConsumerType",
          fieldDesc: this.$t("activities.consumerType"),
          type: "list",
          listSource: this.dataObj.consumerTypes.sort(
            (a, b) => a.value - b.value
          ),
          listValueField: "value",
          listTextField: "text",
          addedDefault: false,
          defaultValue: "-1",
          value: "-1",
          added: false,
        });
      }

      this.dataObj.filterObj.push({
        defaultIndex: 2,
        index: 2,
        field: "CustomerKey",
        fieldDesc: this.$t("activities.customerKey"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 3,
        index: 3,
        field: "Surname",
        fieldDesc: this.$t("activities.surname"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 4,
        index: 4,
        field: "Initial",
        fieldDesc: this.$t("activities.initial"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 5,
        index: 5,
        field: "Address",
        fieldDesc: this.$t("activities.address"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 6,
        index: 6,
        field: "TelephoneNumber",
        fieldDesc: this.$t("activities.telephoneNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 7,
        index: 7,
        field: "IdNumber",
        fieldDesc: this.$t("activities.idNumber"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 8,
        index: 8,
        field: "PIN",
        fieldDesc: this.$t("activities.pin"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.dataObj.filterObj.push({
        defaultIndex: 9,
        index: 9,
        field: "CellPhone",
        fieldDesc: this.$t("activities.cellPhone"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });
    },
    showProperties() {
      this.dataObj.propertyId = this.dataObj.customerProperties[0].propertyId;
      this.showPropertiesList = true;
    },
    selectProperty() {
      this.$parent.selectCustomer(
        this.dataObj.completeTask,
        this.dataObj.customer.customerKey,
        this.dataObj.propertyId
      );
    },
  },
};
